import React from 'react';
import { motion } from 'framer-motion';

const TermsConditions: React.FC = () => {
  return (
    <div className="terms-page">
      {/* Hero Section */}
      <section className="terms-hero">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1>Terms & Conditions</h1>
          <p className="hero-subtitle">
            Legal terms and conditions for using Wevatar services
          </p>
        </motion.div>
        <div className="hero-bg">
          <div className="floating-elements">
            <div className="floating-orb orb-1"></div>
            <div className="floating-orb orb-2"></div>
            <div className="floating-orb orb-3"></div>
          </div>
        </div>
      </section>

      {/* Terms Content */}
      <section className="terms-content">
        <div className="container">
          <motion.div
            className="terms-text"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="last-updated">
              <p><strong>Last Updated:</strong> May 11, 2026</p>
            </div>

            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Wevatar's services, you accept and agree to be bound by the terms and provision
              of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>

            <h2>2. Services Description</h2>
            <p>
              Wevatar provides web development services including but not limited to website development, web application
              development, e-commerce solutions, API integration, and website maintenance. All services are provided
              on a project basis as agreed upon in individual project proposals.
            </p>

            <h2>3. Project Agreement</h2>

            <h3>3.1 Project Scope</h3>
            <p>
              The scope of work for each project will be clearly defined in the project proposal and agreement.
              Any changes to the project scope must be agreed upon in writing and may result in additional charges.
            </p>

            <h3>3.2 Timeline</h3>
            <p>
              Project timelines are estimates based on the agreed scope of work. Delays caused by client feedback,
              content provision, or scope changes may extend the timeline. Wevatar will keep clients informed of
              any potential delays.
            </p>

            <h3>3.3 Client Responsibilities</h3>
            <p>Clients are responsible for:</p>
            <ul>
              <li>Providing all necessary content, images, and materials</li>
              <li>Reviewing and approving designs and functionality within agreed timeframes</li>
              <li>Providing timely feedback and approvals</li>
              <li>Ensuring access to necessary systems or accounts</li>
            </ul>

            <h2>4. Payment Terms</h2>

            <h3>4.1 Pricing</h3>
            <p>
              All pricing is as specified in the project proposal. Prices are exclusive of any applicable taxes,
              hosting fees, domain registration costs, or third-party service fees.
            </p>

            <h3>4.2 Payment Schedule</h3>
            <p>
              Payment terms are as specified in the project agreement. Typically, we require a deposit to commence
              work, with subsequent payments tied to project milestones.
            </p>

            <h3>4.3 Late Payments</h3>
            <p>
              Late payments may result in project delays or suspension of services. Interest may be charged on
              overdue amounts at a rate of 1.5% per month.
            </p>

            <h3>4.4 Refunds</h3>
            <p>
              Refunds are provided based on work completed and as specified in the project agreement.
              Custom development work is generally non-refundable once commenced.
            </p>

            <h2>5. Intellectual Property</h2>

            <h3>5.1 Client Content</h3>
            <p>
              Clients retain ownership of their content, logos, and materials provided for the project.
              Clients warrant that they have the right to use all provided content.
            </p>

            <h3>5.2 Wevatar IP</h3>
            <p>
              Wevatar retains ownership of the underlying code, frameworks, and methodologies used in development.
              Clients receive a license to use the final deliverables for their business purposes.
            </p>

            <h3>5.3 Third-Party Assets</h3>
            <p>
              Wevatar will ensure that all third-party assets used (fonts, icons, libraries) have appropriate licenses
              for the intended use.
            </p>

            <h2>6. Confidentiality</h2>
            <p>
              Both parties agree to maintain confidentiality of proprietary information, client data, and project
              details. This obligation continues beyond the completion of the project.
            </p>

            <h2>7. Warranty and Support</h2>

            <h3>7.1 Warranty</h3>
            <p>
              Wevatar warrants that our work will be performed in a professional manner and will substantially
              conform to the project specifications. We provide a 30-day warranty period for bug fixes.
            </p>

            <h3>7.2 Support</h3>
            <p>
              Post-launch support is provided as specified in the project agreement. Additional support packages
              are available for ongoing maintenance and updates.
            </p>

            <h2>8. Limitation of Liability</h2>
            <p>
              Wevatar's liability is limited to the amount paid for the specific project. We are not liable for
              indirect damages, lost profits, or consequential damages arising from the use of our services.
            </p>

            <h2>9. Termination</h2>
            <p>
              Either party may terminate the agreement with written notice. Upon termination, client will pay
              for all work completed up to the termination date. Outstanding payments become immediately due.
            </p>

            <h2>10. Governing Law</h2>
            <p>
              This agreement shall be governed by and construed in accordance with the laws of India.
              Any disputes shall be resolved through arbitration in Silchar, Assam.
            </p>

            <h2>11. Changes to Terms</h2>
            <p>
              Wevatar reserves the right to modify these terms at any time. Changes will be effective immediately
              upon posting on our website. Continued use of our services constitutes acceptance of the modified terms.
            </p>

            <h2>12. Contact Information</h2>
            <p>
              For questions about these Terms & Conditions, please contact us:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> info@wevatar.com</p>
              <p><strong>Phone:</strong> +91 7896353325</p>
              <p><strong>Address:</strong> Silchar, Assam, India</p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
